import { PropsWithChildren } from 'react';

export const OrganisationAreaSectionActions = ({
  children,
}: PropsWithChildren) => {
  return <div style={{ display: 'flex' }}>{children}</div>;
};
